export default {"src":"/_next/static/media/latest.d5269b5e.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};